<template>
    <div class="about" v-if="loaded && ready">



      <div class="main-about" :class="'screen' + actualScreen">




        <div class="cont-text" v-for="i in 6" :class="'cont-text-' + (i -1)">
          <div class="cont-text-box ">
            <div >
              <h1 v-html="aboutData.item[(i -1)].title[lang].name"></h1>
              <p v-html="aboutData.item[(i -1)].text[lang].name"></p>
            </div>
          </div>
        </div>




        <div class="about-img" :class="'screen' + actualScreen">
          <img class=""  v-for="i in 6" :class="['about-img' + (i -1), {'img-land' : i === 1 ||  i === 5} , {'img-port' : i === 2 ||  i === 3 ||  i === 4 ||  i === 6}]"  :src="aboutData.item[(i -1)].image" :alt="aboutData.item[(i -1)].title[lang].name">



          <ul class="over-bars" :class="'screen' + actualScreen">
            <li class="_top"></li>
            <li class="_bot"></li>
            <li class="_lef"></li>
            <li class="_rig"></li>
          </ul>
        </div>


        <div class="cont-text cont-text-6">
          <div class="cont-text-box ">
            <div>
              <h1 v-html="aboutData.ofer.title[lang].name"></h1>
              <p v-html="aboutData.ofer.text[lang].name"></p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>
          </div>

          <div class="ofer-items">
            <div class="ofer-item" :class="'ofer-item' + index" v-for="(item, index) in aboutData.ofer.item" v-html="item.name[lang].name"> </div>
          </div>
        </div>

        <div class="prizes">
         <div class="prizes-col1":class="'screen' + actualScreen">
           <h1 v-if="lang == 0"> Prémios<br> principais   </h1>
           <h1 v-if="lang == 1"> Main<br> awards   </h1>
         </div>
          <div class="prizes-col2">
            <div  v-for="(item, index) in aboutData.rec" class="prize-item" :class="'screen' + actualScreen">
              <strong>{{item.year}}</strong>
              <div class="prize-item-row">
                <div class="prize-item-col1">{{item.ent}}</div>
                <div class="prize-item-col2">{{item.des[lang].name}}</div>
              </div>

            </div>
          </div>
        </div>

      </div>


      <transition name="fade">
        <div v-if="actualScreen  == 8" class="about-footer">
          <footer-nossa :lang="lang" :isMobile="isMobile" :big="'big'"  ></footer-nossa>

        </div>


      </transition>










    </div>
</template>

<script>


import {NavEvents} from "../dataModules/NavEvents";
    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../main';

    import FooterNossa from "./FooterNossa";





    export default {

        name: 'about',
      components: {FooterNossa},
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {
                actScreen:0,
              aboutData: [],
              simpleBlock: [],
              listBlock: [],
              processBlock: [],
              loaded: false,
              ready: false,


              incPagePos: 0,
              stopInc: false,
              totalScreens: 8,
              actualScreen: -1,

              footerVisited : '',
              main: {},
              stopSwipe: false,
              doneScreen: '',

              navEvt : {},
              animPross:''
            }
        },

      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'Agência'
          }
        },


      },

      created() {

          const _this = this;

        WP('agency', function (response){



          _this.aboutData = response[0];

          console.log(response)
          _this.loaded = true;



          _this.init();


        });

      },
      mounted() {
        this.ready = true;
        this.init();
        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);
        $(window).scrollTop(0);
        $('body, html').scrollTop(0);
      },

      destroyed() {
        this.navEvt.wheelSwitch(false);
      },

      methods: {

        init() {

          const _this = this;

          if(_this.loaded && _this.ready){






            this.navEvt = new NavEvents(document.getElementById('main'), this.incPageAbout, false);
            this.navEvt.wheelSwitch(true);




            setTimeout(function(){

              _this.actualScreen = 0;



            },50);

          }



        },







        /********************************************************************************
         ********************************************************************************
         ********************************************************************************
         ********************************************************************************
         ********************************************************************************/

        /*
        incPageEVT(n){
          if(!this.stopInc){
              if(this.incPagePos >= 0 && n === 0){
                this.incPagePos --;
              }else {
                this.incPagePos ++;
              }
              console.log(this.incPagePos)
            }
        },

         */
        incPageAbout(n){

          const _this = this;
       //   this.wheelSwitch(false);

          if(this.actualScreen > 0 && n === 0){
            this.actualScreen --;
          }

          if(this.actualScreen < this.totalScreens && n === 1){
            this.actualScreen ++;
          }

          if(this.actualScreen === this.totalScreens){
            $('body, html').addClass('about-footer')
          }else{
            $('body, html').removeClass('about-footer')
          }


          var time = 1500 + ((_this.deltaY * 2) * _this.deltaY);
          //   console.log(time)
          // _this.wheelSwitch(true);
          setTimeout(function(){
           // _this.wheelSwitch(true);

          }, time);


          if(_this.actualScreen > 2 && _this.actualScreen < 5){


            setTimeout(function(){
              _this.animPross = 'active';

            }, 100);
          }else{
            _this.animPross = '';
          }

          console.log(this.actualScreen);
        },



        /********************************************************************************
         ********************************************************************************
         ********************************************************************************
         ********************************************************************************
         ********************************************************************************/




        incPageEVT(n){
          const _this = this;

          if(_this.actualScreen > 0 && n === 0){
            _this.actualScreen --;
          }

          if(_this.actualScreen < _this.totalScreens && n === 1){
            _this.actualScreen ++;
          }







          // this.stopInc = true;


        },



        movePageByPass(){

          /*

          totalScreens: 3,
              totalProj: 3,
              actualScreen: 0,
              actualProj: 0,

          EVENTBUS.$emit('incHomeProj', 0);
           */


        },








      },
    };

</script>


// WEBPACK FOOTER //
// src/components/About.vue